import { ref } from 'vue';
import { useEventListener } from '@vueuse/core';

/**
 * Use this composable to call a function when the user starts scrolling.
 *
 * @param {Function} callback
 * @returns {{ isCalled: import('vue').Ref<boolean>, cleanup: Function }}
 */
export const useOnScrollStart = (callback) => {
  /* istanbul ignore file */
  if (typeof callback !== 'function') {
    throw new Error('The callback must be a function');
  }

  if (typeof window === 'undefined') {
    throw new Error('The useOnScrollStart composable must be used in a browser environment');
  }

  const isCalled = ref(false);
  const cleanup = useEventListener(window, 'scroll', (e) => {
    callback(e);
    isCalled.value = true;
    cleanup();
  });

  return {
    isCalled,
    cleanup,
  };
};

export default useOnScrollStart;
